import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Download, Share2, Award, Calendar, CheckCircle, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { useAuth } from '../contexts/AuthContext';
export function CertificateDownloadPage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const certificates = [{
    id: 1,
    title: 'Sertifikat Keanggotaan ATIOS 2025',
    type: 'membership',
    issueDate: '1 Januari 2025',
    validUntil: '31 Desember 2025',
    certificateNumber: 'ATI-2025-001234',
    status: 'active',
    description: 'Sertifikat keanggotaan resmi ATIOS untuk tahun 2025'
  }, {
    id: 2,
    title: 'Workshop React & Next.js Advanced',
    type: 'training',
    issueDate: '16 Januari 2025',
    validUntil: 'Selamanya',
    certificateNumber: 'CERT-WS-2025-0045',
    status: 'completed',
    description: 'Menyelesaikan workshop intensif React & Next.js 2 hari'
  }, {
    id: 3,
    title: 'Seminar AI & Machine Learning 2025',
    type: 'seminar',
    issueDate: '20 Januari 2025',
    validUntil: 'Selamanya',
    certificateNumber: 'CERT-SM-2025-0123',
    status: 'completed',
    description: 'Menghadiri seminar AI & Machine Learning'
  }];
  const handleDownload = (certId: number) => {
    // Simulate download
    alert(`Mengunduh sertifikat #${certId}...`);
  };
  const handleShare = (certId: number) => {
    // Simulate share
    alert(`Membagikan sertifikat #${certId}...`);
  };
  return <div className="min-h-screen bg-white" data-id="element-1295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1296">
        {/* Header */}
        <div className="mb-8" data-id="element-1297">
          <Button variant="ghost" onClick={() => navigate('/benefits')} className="mb-4" data-id="element-1298">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1299" />
            Kembali ke Manfaat
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1300">
            Sertifikat Saya
          </h1>
          <p className="text-neutral-600" data-id="element-1301">Unduh dan bagikan sertifikat Anda</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1302">
          <Card data-id="element-1303">
            <CardContent className="p-6" data-id="element-1304">
              <div className="flex items-center gap-4" data-id="element-1305">
                <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center" data-id="element-1306">
                  <Award className="h-6 w-6 text-atios-primary" data-id="element-1307" />
                </div>
                <div data-id="element-1308">
                  <p className="text-2xl font-semibold text-neutral-900" data-id="element-1309">
                    {certificates.length}
                  </p>
                  <p className="text-sm text-neutral-600" data-id="element-1310">Total Sertifikat</p>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1311">
            <CardContent className="p-6" data-id="element-1312">
              <div className="flex items-center gap-4" data-id="element-1313">
                <div className="h-12 w-12 rounded-lg bg-success-light flex items-center justify-center" data-id="element-1314">
                  <CheckCircle className="h-6 w-6 text-success" data-id="element-1315" />
                </div>
                <div data-id="element-1316">
                  <p className="text-2xl font-semibold text-neutral-900" data-id="element-1317">
                    {certificates.filter(c => c.status === 'active').length}
                  </p>
                  <p className="text-sm text-neutral-600" data-id="element-1318">Sertifikat Aktif</p>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1319">
            <CardContent className="p-6" data-id="element-1320">
              <div className="flex items-center gap-4" data-id="element-1321">
                <div className="h-12 w-12 rounded-lg bg-neutral-100 flex items-center justify-center" data-id="element-1322">
                  <Calendar className="h-6 w-6 text-neutral-700" data-id="element-1323" />
                </div>
                <div data-id="element-1324">
                  <p className="text-2xl font-semibold text-neutral-900" data-id="element-1325">
                    {certificates.filter(c => c.status === 'completed').length}
                  </p>
                  <p className="text-sm text-neutral-600" data-id="element-1326">Sertifikat Selesai</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Certificates List */}
        <div className="space-y-6" data-id="element-1327">
          {certificates.map(cert => <Card key={cert.id} data-id="element-1328">
              <CardContent className="p-6" data-id="element-1329">
                <div className="flex flex-col md:flex-row gap-6" data-id="element-1330">
                  {/* Certificate Preview */}
                  <div className="w-full md:w-64 h-48 bg-gradient-to-br from-atios-light to-white border-2 border-atios-primary/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1331">
                    <div className="text-center" data-id="element-1332">
                      <Award className="w-16 h-16 text-atios-primary mx-auto mb-2" data-id="element-1333" />
                      <p className="text-xs text-neutral-600 font-medium" data-id="element-1334">
                        {cert.certificateNumber}
                      </p>
                    </div>
                  </div>

                  {/* Certificate Details */}
                  <div className="flex-1" data-id="element-1335">
                    <div className="flex items-start justify-between mb-4" data-id="element-1336">
                      <div data-id="element-1337">
                        <h3 className="text-lg font-semibold text-neutral-900 mb-1" data-id="element-1338">
                          {cert.title}
                        </h3>
                        <p className="text-sm text-neutral-600 mb-3" data-id="element-1339">
                          {cert.description}
                        </p>
                      </div>
                      <Badge variant={cert.status === 'active' ? 'success' : 'default'} data-id="element-1340">
                        {cert.status === 'active' ? 'AKTIF' : 'SELESAI'}
                      </Badge>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4" data-id="element-1341">
                      <div data-id="element-1342">
                        <p className="text-xs text-neutral-500 mb-1" data-id="element-1343">
                          Nomor Sertifikat
                        </p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-1344">
                          {cert.certificateNumber}
                        </p>
                      </div>
                      <div data-id="element-1345">
                        <p className="text-xs text-neutral-500 mb-1" data-id="element-1346">
                          Tanggal Terbit
                        </p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-1347">
                          {cert.issueDate}
                        </p>
                      </div>
                      <div data-id="element-1348">
                        <p className="text-xs text-neutral-500 mb-1" data-id="element-1349">
                          Berlaku Hingga
                        </p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-1350">
                          {cert.validUntil}
                        </p>
                      </div>
                    </div>

                    <div className="flex gap-3" data-id="element-1351">
                      <Button size="sm" onClick={() => handleDownload(cert.id)} data-id="element-1352">
                        <Download className="w-4 h-4 mr-2" data-id="element-1353" />
                        Unduh PDF
                      </Button>
                      <Button size="sm" variant="secondary" onClick={() => handleShare(cert.id)} data-id="element-1354">
                        <Share2 className="w-4 h-4 mr-2" data-id="element-1355" />
                        Bagikan
                      </Button>
                      <Button size="sm" variant="secondary" data-id="element-1356">
                        <ExternalLink className="w-4 h-4 mr-2" data-id="element-1357" />
                        Verifikasi
                      </Button>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Info Card */}
        <Card className="mt-8 bg-atios-light border-atios-primary/20" data-id="element-1358">
          <CardContent className="p-6" data-id="element-1359">
            <div className="flex items-start gap-4" data-id="element-1360">
              <Award className="w-6 h-6 text-atios-primary flex-shrink-0 mt-1" data-id="element-1361" />
              <div data-id="element-1362">
                <h3 className="font-semibold text-neutral-900 mb-2" data-id="element-1363">
                  Tentang Sertifikat ATIOS
                </h3>
                <p className="text-sm text-neutral-700 mb-3" data-id="element-1364">
                  Semua sertifikat ATIOS dapat diverifikasi secara online dan
                  diakui oleh industri teknologi di Indonesia. Sertifikat dapat
                  diunduh dalam format PDF dan dibagikan ke LinkedIn atau
                  platform profesional lainnya.
                </p>
                <Button variant="secondary" size="sm" data-id="element-1365">
                  Pelajari Lebih Lanjut
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}